"use strict";

import jQuery from 'jquery';

/**
 * @class
 * @extends gc.gis.GCObservable
 * @memberof gc.gis.ui
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object<string,*>} options
 * @param {string} [options.className=''] CSS-Klasse(n) für den Container
 */
gc.gis.ui.GCToolbar = function(options)
{
	gc.gis.GCObservable.call(this);

	this.className = options.className || '';

	/**
	 * @type {jQuery}
	 * @private
	 */
	this._element = jQuery('<div>', {
		'class': 'gc-toolbar'
			+ (this.className ? ' '+ this.className : '')
	});
};
gc.gis.ui.GCToolbar.prototype = Object.create(gc.gis.GCObservable.prototype);

/**
 * Fügt eine Element der Toolbar hinzu.
 *
 * @param {gc.gis.widget.GCWidget|jQuery} item WidgetItem
 * @param {number} [order] Reihenfolge
 */
gc.gis.ui.GCToolbar.prototype.addItem = function (item, order)
{
	var children = this._element.children(),
		element = item.getElement ? item.getElement() : item;

	if(order <= 0)
	{
		this._element.prepend(element);
	}
	else if(order > 0 && order < children.length)
	{
		children.eq(order).before(element);
	}
	else
	{
		this._element.append(element);
	}
};

/**
 *
 * @return {jQuery}
 */
gc.gis.ui.GCToolbar.prototype.getElement = function ()
{
	return this._element;
};